module.exports = __webpack_public_path__ + "static/media/eila.478ec4b6.png";